// Homepage crest strip (sections/hero.liquid).
//
// Clicks: the hero's focusin handler recenters the strip on the focused crest. A mouse press focuses the link
// first, so the crest slid away before mouseup and the click missed it. Only keyboard focus (Tab) recenters now;
// mouse and touch presses open the school they land on.
document.addEventListener('focusin', (e) => {
  const crest = e.target.closest && e.target.closest('.up-proof__crest');
  if (crest && !crest.matches(':focus-visible')) e.stopPropagation();
}, true);

// Swipes: the hero moves the strip with your finger but stops dead when you let go. This adds momentum, so a
// flick keeps the strip spinning and it slows down on its own. It moves the strip through the hero's own
// sideways-scroll (wheel) handler, which keeps the hero's position, looping and auto-drift in step.
(() => {
  const FRICTION = 0.955;   // speed kept per 16ms frame; higher spins longer
  const MIN_SPEED = 0.02;   // px per ms; slower than this and the spin stops
  const MAX_SPEED = 4;      // px per ms; a cap so a hard flick doesn't fly off

  function attach(box) {
    if (box.dataset.momentum) return;
    box.dataset.momentum = '1';
    let pts = [], raf = 0, active = null;

    const stop = () => { cancelAnimationFrame(raf); raf = 0; };
    box.addEventListener('pointerdown', (e) => {
      stop();
      active = e.pointerId;
      pts = [{ x: e.clientX, t: e.timeStamp }];
    }, true);
    box.addEventListener('pointermove', (e) => {
      if (e.pointerId !== active) return;
      pts.push({ x: e.clientX, t: e.timeStamp });
      if (pts.length > 6) pts.shift();
    }, true);
    const release = (e) => {
      if (e.pointerId !== active) return;
      active = null;
      // Speed over the last ~100ms of the swipe. Finger left = strip moves on (positive x in the hero).
      const last = pts[pts.length - 1];
      const first = pts.find((p) => last.t - p.t <= 100) || pts[0];
      const dt = last.t - first.t;
      if (!last || dt <= 0 || Math.abs(last.x - pts[0].x) < 10) return;
      let v = Math.max(-MAX_SPEED, Math.min(MAX_SPEED, -(last.x - first.x) / dt));
      if (Math.abs(v) < MIN_SPEED * 3) return;
      let prev = performance.now();
      const step = (now) => {
        const ms = Math.min(48, now - prev);
        prev = now;
        box.dispatchEvent(new WheelEvent('wheel', { deltaX: v * ms, deltaY: 0, bubbles: true, cancelable: true }));
        v *= Math.pow(FRICTION, ms / 16);
        raf = Math.abs(v) > MIN_SPEED ? requestAnimationFrame(step) : 0;
      };
      raf = requestAnimationFrame(step);
    };
    box.addEventListener('pointerup', release, true);
    box.addEventListener('pointercancel', release, true);
  }

  const init = () => document.querySelectorAll('.up-proof__crests.is-js').forEach(attach);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();